import { formatDate } from '@app/functions/date-format';
import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';
import { TimeOffDay } from '@models/time-off-v3/time-off-day.model';

export class DateObserved extends Column {
    title = 'time-off-v3.dateObserved';
    type: CellDisplay = CellDisplay.string;
    sortField = 'date';

    getDisplayPropertyValue(timeOffDay: TimeOffDay): string | null {
        return formatDate(timeOffDay.date, 'longWeekday', timeOffDay.locale);
    }
}
